import { User } from "modules/login/models/User";
import { TFirestoreTimestamp } from "common/types/FirebaseTypes";

export class RateLibrary {
  name: string;
  publicLibrary: boolean;
  status: string;
  users: object;
  createdAt?: TFirestoreTimestamp;
  description?: string;
  files?: object;
  location?: string[];
  share?: string[];
  image?: string;
  imageName?: string;
  modifiedAt?: TFirestoreTimestamp;
  ownerName?: string;
  ownerPhoto?: string;
  sharedUsers?: Array<User>;
  typeError?: string = "";

  constructor(
    name: string,
    publicLibrary: boolean,
    status: string,
    users: object,
    typeError: string,
    createdAt?: TFirestoreTimestamp,
    description?: string,
    files?: object,
    location?: string[],
    share?: string[],
    image?: string,
    imageName?: string,
    modifiedAt?: TFirestoreTimestamp,
    ownerName?: string,
    ownerPhoto?: string,
    sharedUsers?: Array<User>
  ) {
    this.name = name;
    this.typeError = typeError;
    this.publicLibrary = publicLibrary;
    this.status = status;
    this.users = users;
    this.createdAt = createdAt;
    this.description = description;
    this.files = files;
    this.location = location;
    this.share = share;
    this.image = image;
    this.imageName = imageName;
    this.modifiedAt = modifiedAt;
    this.ownerName = ownerName;
    this.ownerPhoto = ownerPhoto;
    this.sharedUsers = sharedUsers;
  }

  public static getDefault(): RateLibrary {
    return new RateLibrary("", false, "error", [], "");
  }
}



// WEBPACK FOOTER //
// ./src/modules/rateLibrary/models/RateLibrary.ts